module.exports = __webpack_public_path__ + "img/MLW_I.85e38548.svg";